import {
  Content,
  Item,
  ItemText,
  Root,
  ScrollDownButton,
  ScrollUpButton,
  Trigger,
  Value,
  Viewport,
} from "@radix-ui/react-select";
import { cn } from "@/utils";

interface SelectProps {
  options: SelectOption[];
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
  width?: number;
}

interface SelectOption {
  name: string;
  value: string;
}

export const Select = ({
  options,
  value,
  onValueChange,
  className,
  width,
}: SelectProps) => {
  return (
    <Root value={value} onValueChange={onValueChange}>
      <Trigger
        style={{ width: `${width}px` }}
        className={cn(
          `p2-medium text-item-primary hover:bg-surface-secondary border-border rounded-lg border py-2.5`,
          className,
        )}
      >
        <Value />
      </Trigger>
      <Content
        style={{ width: `${width}px` }}
        className={`bg-surface-primary border-border rounded-lg border`}
        position="popper"
        sideOffset={8}
      >
        <Viewport className="max-h-44">
          <ScrollUpButton />
          {options.map(({ name, value }) => {
            return (
              <Item
                key={value}
                value={value}
                className="p2-medium hover:bg-surface-secondary cursor-pointer rounded-lg px-3 py-2 text-center"
              >
                <ItemText className="text-item-primary">{name}</ItemText>
              </Item>
            );
          })}
          <ScrollDownButton />
        </Viewport>
      </Content>
    </Root>
  );
};
